import React from 'react'
import { FormContext } from 'react-hook-form'
import { useAiPreviewForm, IAISubtaskStepProps } from '../../hooks/useAiPreviewForm'
import { AIDescriptionSection } from './AIDescriptionSection'
import AIImageSubtaskPreview from './AIImageSubtaskPreview'
import AIOpenQuestionWidget from './AIOpenQuestionWidget'
import TaskSummary from './TaskSummary'
import TaskTitle from 'components/TasksV2/TaskCreation/Steps/SubtaskCreationStep/TaskTitle'
import AIMessage from '../../AIMessage'
import styles from './styles.module.css'

export default function AISubtaskStep({ showSummary = true, showTaskTitle = true, ...props }: IAISubtaskStepProps) {
  const form = useAiPreviewForm(props)

  return (
    <div className={styles.preview}>
      <AIMessage
        title={form.t_ai_message}
        subtitle={form.t_ai_message_msg}
        generatingTitle={form.t_ai_generating_header}
        generatingSubtitle={form.t_ai_generating_subtitle}
      />
      {!form.isGenerating && (
        <FormContext {...form.methods}>
          <div className={styles.card}>
            {showSummary && <TaskSummary />}
            {showTaskTitle && <TaskTitle showLabel textAlign="start" formControlWidth="100%" inputBoxShadow="none" />}
            {!form.isQuestion && <AIDescriptionSection subtaskPath="sub_tasks[0]" />}
            {form.isQuestion ? (
              <AIOpenQuestionWidget subtaskPath="sub_tasks[0]" />
            ) : (
              <AIImageSubtaskPreview subtaskPath="sub_tasks[0]" />
            )}
          </div>
        </FormContext>
      )}
    </div>
  )
}
